import {
  useV2Farms,
  useV2FarmsRush,
  useLydiaFarms,
  useLydiaFarmRewardRate,
  useJoeFarmsGlobalData,
  useJoeV3FarmsGlobalData,
  useJoeV3Farms,
  useBenqiFarmsGlobalData,
  usePricePefiUsdt,
  usePriceAvaxUsdt,
} from 'state/hooks'
import useTokenPrice from 'hooks/useTokenPrice'
import useJoePrice from 'hooks/useJoePrice'
import { getBalanceNumber } from 'utils/formatBalance'
import { DAYS_PER_YEAR } from 'config'
import { getAddress } from 'utils/addressHelpers'
import { getApr, getFarmApr, getLydiaFarmApr, getJoeFarmApr, getBenqiFarmApr } from 'utils/apyHelpers'

const useHighestIglooApr = () => {
  const v2Farms = useV2Farms()
  const v2FarmsRush = useV2FarmsRush()
  const lydiaFarms = useLydiaFarms()
  const joeV3Farms = useJoeV3Farms()
  const lydPerSec = useLydiaFarmRewardRate()
  const joeGlobalData = useJoeFarmsGlobalData()
  const joeV3GlobalData = useJoeV3FarmsGlobalData()
  const benqiGlobalData = useBenqiFarmsGlobalData()
  const pefiPriceUsd = usePricePefiUsdt().toNumber()
  const avaxPriceUsd = usePriceAvaxUsdt().toNumber()
  const { lydPrice: lydPriceUsd, qiPrice: qiPriceUsd } = useTokenPrice()
  const joePriceUsd = useJoePrice()
  // const activeFarms = v2Farms.filter((farm) => Number(farm.multiplier) > 0)
  const activeFarms = v2Farms
  
  let maxApr = 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const farm of activeFarms) {
    const pefiPerYear = getBalanceNumber(farm.pefiPerYear)
    const pefiPerDay = pefiPerYear / DAYS_PER_YEAR
    const pefiRewardPerDayInUsd = pefiPriceUsd * pefiPerDay * (1 - 0.15 - 0.1)
    const pefiDailyApr = farm.totalLiquidityInUsd > 0 ? pefiRewardPerDayInUsd / farm.totalLiquidityInUsd : 0
    const pefiApr = getApr(pefiDailyApr)

    // minw apr
    const minwApr = 0
    let { stakingApr, swapFeeApr } = farm
    let joeRushRewardApr = 0
    let penguinRushRewardApr = 0

    if (farm.isPenguinRush) {
      const v2FarmRush = v2FarmsRush.find((row) => row.pid === farm.pid)
      const penguinRushRewardPerSec = v2FarmRush ? v2FarmRush.penguinRushRewardPerSec : 0
      penguinRushRewardApr = getFarmApr(avaxPriceUsd, farm.totalLiquidityInUsd, penguinRushRewardPerSec)
    }

    if (farm.type === 'Lydia') {
      const lydiaFarm = lydiaFarms.find((row) => row.lpSymbol === farm.lpSymbol)
      const poolLiquidityUsd = farm.lpPrice * getBalanceNumber(lydiaFarm.lpTokenBalanceMC)
      stakingApr = getLydiaFarmApr(lydiaFarm.poolWeight, lydPriceUsd, poolLiquidityUsd, lydPerSec) * 0.9
      swapFeeApr = getApr(farm.swapDailyReward / poolLiquidityUsd)
    }

    if (farm.type === 'Joe') {
      const poolLiquidityUsd = farm.lpPrice * Number(farm.joePoolLpBalance)
      let farmAllocPoint = farm.joePoolAllocPoint
      if (farm.isJoeRush) {
        const joeV3Farm = joeV3Farms.find(
          (row) => getAddress(row.lpAddresses).toLowerCase() === getAddress(farm.lpAddresses).toLowerCase(),
        )
        if (joeV3Farm) {
          farmAllocPoint = joeV3Farm.allocPoint
          joeRushRewardApr = getFarmApr(avaxPriceUsd, poolLiquidityUsd, joeV3Farm.joeRushRewardPerSec) * 0.9
        }
      }
      const poolWeight = farm.isJoeRush
        ? farmAllocPoint / joeV3GlobalData.totalAllocPoint
        : farmAllocPoint / joeGlobalData.totalAllocPoint
      stakingApr =
        getJoeFarmApr(
          poolWeight,
          joePriceUsd,
          poolLiquidityUsd,
          farm.isJoeRush ? joeV3GlobalData.joePerSec : joeGlobalData.joePerSec,
          farm.isJoeRush ? 1 : joeGlobalData.rewardPercentToFarm,
        ) * 0.9
      swapFeeApr = getApr(farm.swapDailyReward / (farm.joeSwapPoolUsdBalance || 1))
    }
    if (farm.isBenqi) {
      const { avaxPerSec: benqiAvaxRewardPerSec, benqiPerSec: benqiRewardPerSec, totalSupply } = benqiGlobalData
      const benqiPoolLiquidityUsd = farm.lpPrice * totalSupply
      const avaxStakingApr = getBenqiFarmApr(avaxPriceUsd, benqiPoolLiquidityUsd, benqiAvaxRewardPerSec)
      const qiStakingApr = getBenqiFarmApr(qiPriceUsd, benqiPoolLiquidityUsd, benqiRewardPerSec)
      stakingApr = avaxStakingApr + qiStakingApr
    }

    const totalApr = stakingApr + swapFeeApr + pefiApr + minwApr + joeRushRewardApr + penguinRushRewardApr

    if (maxApr < totalApr) {
      maxApr = totalApr;
    }
  }
  

  return maxApr;
};

export default useHighestIglooApr;